import {FreeDataCriteria} from './FreeDataCriteria';

export class FreeDataValueCriteria extends FreeDataCriteria {
codeOrShort: string;
freeDataCode: string;
}

